import { render, staticRenderFns } from "./building.vue?vue&type=template&id=27163382&scoped=true&"
import script from "./building.vue?vue&type=script&lang=ts&"
export * from "./building.vue?vue&type=script&lang=ts&"
import style0 from "./building.vue?vue&type=style&index=0&id=27163382&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27163382",
  null
  
)

export default component.exports